import type { SwitchProps } from '@byecode/ui'
import { Switch, Text } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import type { ReactNode } from 'react'
import React, { forwardRef } from 'react'

interface SwitchControlProps extends SwitchProps {
    label?: ReactNode
    enableHover?: boolean
    enablePadding?: boolean
}

export const SwitchControl = forwardRef<HTMLInputElement, SwitchControlProps>(({ label, enableHover, enablePadding, ...rest }, ref) => {
    return (
        <ListItem4ByecodeUi enableHover={enableHover} enablePadding={enablePadding} justifyContent="space-between" alignItems="center">
            {label && typeof label === 'string' ? <Text>{label}</Text> : label}
            <Switch {...rest} ref={ref} />
        </ListItem4ByecodeUi>
    )
})
